import React, { useState } from 'react';
import TeamWorkflowSVG from './TeamWorkflowSVG';
import TeamNotificationRules from './TeamNotificationRules';

const TeamCollaborationExplainer = ({ 
  showTitle = true, 
  compact = false,
  placement = 'full' // 'full', 'modal', 'sidebar'
}) => {
  const [viewMode, setViewMode] = useState('visual'); // 'visual', 'rules', 'both'
  
  const containerStyle = {
    full: {
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      borderRadius: '16px',
      padding: '24px',
      margin: '20px 0',
      border: '1px solid #e2e8f0',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)'
    },
    modal: {
      background: 'white',
      borderRadius: '12px',
      padding: '20px',
      maxHeight: '90vh',
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%',
      maxWidth: '750px',
      margin: '0 auto',
      position: 'relative',
      left: '0',
      right: '0'
    },
    sidebar: {
      background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
      borderRadius: '12px',
      padding: '16px',
      border: '2px solid #3b82f6'
    }
  };

  return (
    <div style={containerStyle[placement]}>
      {showTitle && (
        <div style={{
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{
            color: '#1e293b',
            fontSize: compact ? '20px' : '24px',
            fontWeight: '700',
            margin: '0 0 8px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px'
          }}>
            <span style={{ fontSize: compact ? '24px' : '28px' }}>🤝</span>
            How Team Collaboration Works
          </h3>
          <p style={{
            color: '#64748b',
            fontSize: '16px',
            margin: 0,
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Smart notification routing ensures the right people get notified at the right time
          </p>
        </div>
      )}

      {/* View Mode Toggle (for full placement) */}
      {placement === 'full' && !compact && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '10px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '4px',
            border: '2px solid #e2e8f0',
            display: 'flex',
            gap: '4px'
          }}>
            {[
              { key: 'visual', label: '📊 Visual Flow', icon: '🎨' },
              { key: 'rules', label: '📋 Rules Only', icon: '📝' },
              { key: 'both', label: '🔄 Complete View', icon: '👁️' }
            ].map((mode) => (
              <button
                key={mode.key}
                onClick={() => setViewMode(mode.key)}
                style={{
                  background: viewMode === mode.key ? '#3b82f6' : 'transparent',
                  color: viewMode === mode.key ? 'white' : '#64748b',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
                onMouseEnter={(e) => {
                  if (viewMode !== mode.key) {
                    e.target.style.background = '#f1f5f9';
                  }
                }}
                onMouseLeave={(e) => {
                  if (viewMode !== mode.key) {
                    e.target.style.background = 'transparent';
                  }
                }}
              >
                <span>{mode.icon}</span>
                {mode.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Content based on view mode and placement */}
      {(viewMode === 'visual' || viewMode === 'both' || placement !== 'full') && (
                <TeamWorkflowSVG compact={true} context={placement} />
      )}

      {(viewMode === 'rules' || viewMode === 'both' || placement === 'sidebar') && (
        <TeamNotificationRules style={compact || placement === 'sidebar' ? 'inline' : 'cards'} />
      )}

      {/* Quick Benefits Summary */}
    </div>
  );
};

export default TeamCollaborationExplainer;